module.exports = __webpack_public_path__ + "img/66600.a45017f4.jpg";